import { SVGInterface } from "../../interface";

const House = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M19 22H5C4.44772 22 4 21.5523 4 21V11.357C4.01549 11.1119 4.11964 10.8809 4.293 10.707L11.293 3.70698C11.4806 3.51921 11.7351 3.4137 12.0005 3.4137C12.2659 3.4137 12.5204 3.51921 12.708 3.70698L19.708 10.707C19.8957 10.8943 20.0009 11.1488 20 11.414V21C20 21.5523 19.5523 22 19 22ZM12 5.82798L6 11.828V20H18V11.828L12 5.82798ZM12 17.999C11.792 17.814 11.557 17.621 11.308 17.417L11.261 17.379C10.104 16.435 8.661 15.26 8.661 13.799C8.66116 13.3149 8.85626 12.8513 9.20228 12.5129C9.5483 12.1744 10.0161 11.9895 10.5 12C11.0722 11.9984 11.6179 12.2411 12 12.667C12.3822 12.2412 12.9278 11.9986 13.5 12C13.9834 11.9906 14.4503 12.1761 14.7955 12.5147C15.1407 12.8532 15.3351 13.3165 15.335 13.8C15.335 15.266 13.883 16.449 12.717 17.4L12.66 17.447C12.423 17.641 12.199 17.824 11.999 18.001L12 17.999Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default House;
